import keys from 'lodash/keys';
import omit from 'lodash/omit';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
//import get from 'lodash/get';
//import cn from 'classnames';
import css from './css.css';
import { StyleSheet } from "~/native-ui";
import WebsailIcon from "~/icons/WebsailIcon";

let propTypes = {
    icon: PropTypes.string,
	"icon-family": PropTypes.string,
};
let ownPropNames = keys(propTypes);

export default class Icon extends Component {
	static propTypes = propTypes;

	static defaultProps = {
        maxLength: 100
	};

	state = {
        expanded: false
	};

    ownProps = () => {
        return omit(this.props, ownPropNames);
    };

	render() {
		return <WebsailIcon
			style={StyleSheet.flatten([this.props.style, { fontSize:'inherit', verticalAlign: 'middle' }])}
			value={this.props.icon}
			iconFamily={this.props["icon-family"]}
			{...this.ownProps()}
		/>
	}
}